import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ArenaProblemElement } from '@/domain/entities/arena/arenaProblemElement'
import { ArenaUserEntry } from '@/domain/entities/arena/arenaUserEntry'
import { ArenaModuleName } from '@/store/modules/modules'

export class ArenaViewModel {
  private store = useStore()

  arenaId: ComputedRef<string> = computed(() => this.store.getters[`${ArenaModuleName}/arenaId`])
  arenaProblemId: ComputedRef<string> = computed(() => this.store.getters[`${ArenaModuleName}/arenaProblemId`])
  arenaProblemIndex: ComputedRef<number> = computed(() => this.store.getters[`${ArenaModuleName}/arenaProblemIndex`])
  arenaUserEntryList: ComputedRef<ArenaUserEntry[]> = computed(
    () => this.store.getters[`${ArenaModuleName}/arenaUserEntryList`]
  )
  arenaProblemElementList: ComputedRef<ArenaProblemElement[]> = computed(
    () => this.store.getters[`${ArenaModuleName}/arenaProblemElementList`]
  )
  arenaSolvedProblemList: ComputedRef<Set<string>> = computed(
    () => this.store.getters[`${ArenaModuleName}/arenaSolvedProblemList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${ArenaModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${ArenaModuleName}/error`])

  setArenaProblem(arenaId: string, arenaProblemId: string, arenaProblemIndex: number): void {
    this.store.commit(`${ArenaModuleName}/setArenaId`, arenaId)
    this.store.commit(`${ArenaModuleName}/setArenaProblemId`, arenaProblemId)
    this.store.commit(`${ArenaModuleName}/setArenaProblemIndex`, arenaProblemIndex)
  }

  async getByUserIdArenaEntryList(userId: string): Promise<void> {
    await this.store.dispatch(`${ArenaModuleName}/getByUserIdArenaEntryList`, { userId: userId })
  }

  async getArenaDetailData(arenaId: string, userId: string): Promise<void> {
    await this.store.dispatch(`${ArenaModuleName}/getArenaDetailData`, { arenaId: arenaId, userId: userId })
  }
}
